import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

/**
 * Links to the two public legal documents, shown in the app footer and on the
 * login page so they are reachable both before and after signing in.
 */
export function LegalLinks({ className }: { className?: string }) {
  const { t } = useTranslation('legal')
  return (
    <p className={className}>
      <Link to="/privacy" className="hover:underline">
        {t('privacy.title')}
      </Link>
      <span aria-hidden="true" className="mx-2">
        ·
      </span>
      <Link to="/terms" className="hover:underline">
        {t('terms.title')}
      </Link>
    </p>
  )
}
